import { Button, Stack, TextField, Typography } from '@mui/material';
import { MprcBoxDrawer, MprcContainer } from 'components';
import { PublicationActionResponse } from 'generated/CoreApi_v1';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

export type AdjustPublicationDialogResult = {
    status: PublicationActionResponse;
    message: string | null;
};

interface IProps {
    title: string | null;
    onClose: (result: AdjustPublicationDialogResult | undefined) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const AdjustPublicationDrawer: React.FC<IProps> = (props) => {

    const { title, onClose } = props;
    const { t } = useTranslation("knowledge");
    const [text, setText] = useState<string | null>(null);

    return (
        <MprcBoxDrawer
            title={t("Feed.Card.Actions.AdjustPublicationDrawer.Title")}
            subtitle={title}
            onClose={() => onClose(undefined)}
            content={
                <>
                    <MprcContainer>
                        <TextField
                            value={text}
                            placeholder={t("Feed.Card.Actions.AdjustPublicationDrawer.Placeholder")}
                            multiline={true}
                            rows={10}
                            onChange={(e) => setText(e.target.value)}
                            fullWidth
                            variant="outlined"
                            helperText={t("Feed.Card.Actions.AdjustPublicationDrawer.HelpText")}
                            margin="normal"
                        />
                    </MprcContainer>

                    <Stack direction="column" spacing={2} justifyItems="center">
                        <Typography variant="h4" textAlign="center">
                            {t("Feed.Card.Actions.AdjustPublicationDrawer.ActionTitle")}
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => onClose({ status: PublicationActionResponse.ApprovePublication, message: text })}
                        >
                            {t("Feed.Card.Actions.AdjustPublicationDrawer.ApproveButtonText")}
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => onClose({ status: PublicationActionResponse.RejectPublication, message: text })}
                        >
                            {t("Feed.Card.Actions.AdjustPublicationDrawer.RejectButtonText")}
                        </Button>

                    </Stack>

                </>
            }
        />
    );
};
